"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgStarHollow(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm8 2.8253 1.3463 2.8208.3449.7227.7924.1156 3.0308.442-2.1596 2.0977-.5636.5475.1292.775.5034 3.02-2.7406-1.402-.6832-.3495-.6832.35-2.6992 1.381.5567-2.9692.1484-.7917-.5781-.561-2.1738-2.11 2.9456-.43.7924-.1156.3449-.7227zm-.0052-2.6386a.6437.6437 0 0 0 -.5948.4133l-2.1 4.4-4.8.7c-.6.1-.6.7-.2 1.1l3.4 3.3-.9 4.8c-.0709.4963.21.691.5222.691a.86.86 0 0 0 .3778-.091l4.3-2.2 4.3 2.2a.79113.79113 0 0 0 .3533.0915.56311.56311 0 0 0 .5467-.6915l-.8-4.8 3.5-3.4a.66889.66889 0 0 0 -.4-1l-4.8-.7-2.1-4.4a.6788.6788 0 0 0 -.6052-.4133z' })));
}
exports.default = SvgStarHollow;
